export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';
export const GET_USER_VALIDATE_LIST_SUCCESS = 'GET_USER_VALIDATE_LIST_SUCCESS';
export const GET_USER_VALIDATE_LIST_FAILURE = 'GET_USER_VALIDATE_LIST_FAILURE';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const CHANGE_USER_STATUS_SUCCESS = 'CHANGE_USER_STATUS_SUCCESS';
export const VALIDATE_USER_STATUS_SUCCESS = 'VALIDATE_USER_STATUS_SUCCESS';
export const GET_UD_USER_SUCCESS = 'GET_UD_USER_SUCCESS';
export const GET_UD_USER_FAILURE = 'GET_UD_USER_FAILURE';

export const GET_VIP_LIST_SUCCESS = 'GET_VIP_LIST_SUCCESS';
export const GET_VIP_LIST_FAILURE = 'GET_VIP_LIST_FAILURE';

export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE';
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';

export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';

export const GET_DASHBOARD_LIST_SUCCESS = 'GET_DASHBOARD_LIST_SUCCESS'
export const GET_DASHBOARD_LIST_FAILURE = 'GET_DASHBOARD_LIST_FAILURE'
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'

export const GET_SUPPORT_LIST_SUCCESS = 'GET_SUPPORT_LIST_SUCCESS'
export const GET_SUPPORT_LIST_FAILURE = 'GET_SUPPORT_LIST_FAILURE'
export const GET_SUPPORT_FAILURE = 'GET_SUPPORT_FAILURE'
export const GET_SUPPORT_SUCCESS = 'GET_SUPPORT_SUCCESS'
export const UPDATE_SUPPORT_SUCCESS = 'UPDATE_SUPPORT_SUCCESS'

export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS'
export const GET_NOTIFICATION_LIST_FAILURE = 'GET_NOTIFICATION_LIST_FAILURE'
export const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE'
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS'
export const UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS'
export const CHANGE_NOTIFICATION_STATUS_SUCCESS = 'CHANGE_NOTIFICATION_STATUS_SUCCESS'

export const GET_PAYMENT_LIST_SUCCESS = 'GET_PAYMENT_LIST_SUCCESS'
export const GET_PAYMENT_LIST_FAILURE = 'GET_PAYMENT_LIST_FAILURE'
export const GET_PAYMENT_FAILURE = 'GET_PAYMENT_FAILURE'
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS'
export const UPDATE_PAYMENT_SUCCESS = 'UPDATE_PAYMENT_SUCCESS'

export const GET_MATERIAL_LIST_SUCCESS = 'GET_MATERIAL_LIST_SUCCESS'
export const GET_MATERIAL_LIST_FAILURE = 'GET_MATERIAL_LIST_FAILURE'
export const GET_MATERIAL_FAILURE = 'GET_MATERIAL_FAILURE'
export const GET_MATERIAL_SUCCESS = 'GET_MATERIAL_SUCCESS'
export const UPDATE_MATERIAL_SUCCESS = 'UPDATE_MATERIAL_SUCCESS'

export const GET_CATEGORY_LIST_SUCCESS = 'GET_CATEGORY_LIST_SUCCESS'
export const GET_CATEGORY_LIST_FAILURE = 'GET_CATEGORY_LIST_FAILURE'
export const GET_CATEGORY_FAILURE = 'GET_CATEGORY_FAILURE'
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS'

export const GET_TYPEFUEL_LIST_SUCCESS = 'GET_TYPEFUEL_LIST_SUCCESS'
export const GET_TYPEFUEL_LIST_FAILURE = 'GET_TYPEFUEL_LIST_FAILURE'
export const GET_TYPEFUEL_FAILURE = 'GET_TYPEFUEL_FAILURE'
export const GET_TYPEFUEL_SUCCESS = 'GET_TYPEFUEL_SUCCESS'
export const UPDATE_TYPEFUEL_SUCCESS = 'UPDATE_TYPEFUEL_SUCCESS'

export const GET_COLORS_LIST_SUCCESS = 'GET_COLORS_LIST_SUCCESS'
export const GET_COLORS_LIST_FAILURE = 'GET_COLORS_LIST_FAILURE'
export const GET_COLORS_FAILURE = 'GET_COLORS_FAILURE'
export const GET_COLORS_SUCCESS = 'GET_COLORS_SUCCESS'
export const UPDATE_COLORS_SUCCESS = 'UPDATE_COLORS_SUCCESS'

export const GET_MANUFACTURE_LIST_SUCCESS = 'GET_MANUFACTURE_LIST_SUCCESS'
export const GET_MANUFACTURE_LIST_FAILURE = 'GET_MANUFACTURE_LIST_FAILURE'
export const GET_MANUFACTURE_FAILURE = 'GET_MANUFACTURE_FAILURE'
export const GET_MANUFACTURE_SUCCESS = 'GET_MANUFACTURE_SUCCESS'
export const UPDATE_MANUFACTURE_SUCCESS = 'UPDATE_MANUFACTURE_SUCCESS'

export const GET_MEASURE_LIST_SUCCESS = 'GET_MEASURE_LIST_SUCCESS'
export const GET_MEASURE_LIST_FAILURE = 'GET_MEASURE_LIST_FAILURE'
export const GET_MEASURE_FAILURE = 'GET_MEASURE_FAILURE'
export const GET_MEASURE_SUCCESS = 'GET_MEASURE_SUCCESS'
export const UPDATE_MEASURE_SUCCESS = 'UPDATE_MEASURE_SUCCESS'

export const GET_CAR_LIST_SUCCESS = 'GET_CAR_LIST_SUCCESS'
export const GET_CAR_LIST_FAILURE = 'GET_CAR_LIST_FAILURE'
export const GET_CAR_FAILURE = 'GET_CAR_FAILURE'
export const GET_CAR_SUCCESS = 'GET_CAR_SUCCESS'
export const UPDATE_CAR_SUCCESS = 'UPDATE_CAR_SUCCESS'
export const GET_CAR_VALIDATE_LIST_SUCCESS = 'GET_CAR_VALIDATE_LIST_SUCCESS';
export const GET_CAR_VALIDATE_LIST_FAILURE = 'GET_CAR_VALIDATE_LIST_FAILURE';

export const GET_SELLER_LIST_SUCCESS = 'GET_SELLER_LIST_SUCCESS'
export const GET_SELLER_LIST_FAILURE = 'GET_SELLER_LIST_FAILURE'
export const GET_SELLER_FAILURE = 'GET_SELLER_FAILURE'
export const GET_SELLER_SUCCESS = 'GET_SELLER_SUCCESS'
export const UPDATE_SELLER_SUCCESS = 'UPDATE_SELLER_SUCCESS'

export const GET_AUCTION_LIST_SUCCESS = 'GET_AUCTION_LIST_SUCCESS'
export const GET_AUCTION_LIST_FAILURE = 'GET_AUCTION_LIST_FAILURE'
export const GET_AUCTION_FAILURE = 'GET_AUCTION_FAILURE'
export const GET_AUCTION_SUCCESS = 'GET_AUCTION_SUCCESS'
export const UPDATE_AUCTION_SUCCESS = 'UPDATE_AUCTION_SUCCESS'

export const GET_PROMOTION_LIST_SUCCESS = 'GET_PROMOTION_LIST_SUCCESS'
export const GET_PROMOTION_LIST_FAILURE = 'GET_PROMOTION_LIST_FAILURE'
export const GET_PROMOTION_FAILURE = 'GET_PROMOTION_FAILURE'
export const GET_PROMOTION_SUCCESS = 'GET_PROMOTION_SUCCESS'
export const UPDATE_PROMOTION_SUCCESS = 'UPDATE_PROMOTION_SUCCESS'



// WEBPACK FOOTER //
// ./src/store/types.js